<template>
  <div class="module-afiliasi">
    <SOSlotModal :modal-title="`Konfirmasi`" :modal-id="`modal${dataId}`" @close="back">
      <template v-slot:modal-body>
        <div>
          <div>
            <label class="m-d-16 f-14 f-c-midgrey f-regular">
              Pastikan rekening tarik tunai anda sudah benar sebelum melanjutkan
            </label>
          </div>
          <div class="d-grid-2 f-16 f-regular f-c-midgrey m-d-8">
            <label class="m-d-8">Nomor Rekening</label>
            <label class="m-d-8 j-self-end f-c-black">{{ rekening.noRekening }}</label>
            <label class="m-d-8">Bank</label>
            <label class="m-d-8 j-self-end f-c-black nama-bank">{{ rekening.namaBank }}</label>
            <label class="m-d-8">Atas Nama</label>
            <label class="m-d-8 j-self-end f-c-black">{{ rekening.pemilik }}</label>
          </div>
          <div>
            <label class="m-d-0 f-14 f-c-midgrey f-regular">Penarikan diproses tanggal 7-9 di bulan ini</label>
          </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div>
          <SOButton
            :outline="true"
            :full="true"
            :text="'Ya, Rekening Saya Sudah Benar'"
            :id="dataId"
            :disable="isFetching"
            :loading="isFetching"
            @action="doWithdraw"
          />
        </div>
      </template>
    </SOSlotModal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

export default {
  name: "SOModalWithdraw",
  components: {
    SOSlotModal,
    SOButton,
  },
  mounted() {
    $(`#modal${this.dataId}`).modal("show");
  },
  watch: {
    response: function(newRes, oldRes) {
      if (newRes !== oldRes) {
        this.closeModal();
        if (newRes.success === true) {
          this.$router.push({ name: "afiliasi.verif_otp" });
        } else {
          this.back();
          this.$toast.error(newRes.err);
        }
      }
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      response: "getResponse",
      isFetching: "isFecthing",
      afiliasiSet: "afiliasiSet",
      detailOwner: "detailOwner",
    }),
    rekening() {
      return this.afiliasiSet.rekening;
    },
    dataId() {
      return "confirm-withdraw";
    },
  },
  methods: {
    ...mapActions({
      sendOTP: `${moduleName}/sendOTP`,
    }),
    closeModal() {
      $(`#modal${this.dataId}`).modal("hide");
    },
    back() {
      this.closeModal();
      this.$router.push({ name: "afiliasi.dashboard.withdraw" });
    },
    doWithdraw() {
      this.sendOTP(this.detailOwner.telp);
    },
  },
};
</script>

<style scoped src="../styleScope.css"></style>
<style scoped>
.nama-bank {
  width: 60vw;
}
</style>
